<template>
    <div>
        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model :form="form" :layout="formLayout" :model="formData">
                    <a-divider dashed orientation="left">Form Modul</a-divider>

                        <a-form-model-item label="Modul">
                            <a-select v-model="formData.module">
                                <a-select-option
                                    v-for="d in modulesAdd"
                                    :key="d.value"
                                    :value="d.value"
                                >
                                    {{ d.label }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>

                        <a-form-model-item label="Tanggal Mulai">
                            <a-date-picker
                                v-model="formData.date_start"
                                @change="onStartDateChange"
                                :format="'YYYY-MM-DD'"
                                type="date"
                                placeholder="Pick a date"
                            />
                        </a-form-model-item>

                        <a-form-model-item label="Tanggal Berakhir">
                            <a-date-picker
                                v-model="formData.date_end"
                                @change="onEndDateChange"
                                :format="'YYYY-MM-DD'"
                                type="date"
                                placeholder="Pick a date"
                            />
                        </a-form-model-item>

                        <a-form-model-item label="Bobot (%)">
                            <a-input v-model="formData.weight"/>
                        </a-form-model-item>

                        <a-form-model-item>
                            <a-row type="flex" justify="center" align="top">
                                <a-col>
                                    <a-space>
                                        <a-button
                                            type="primary"
                                            html-type="submit"
                                            :loading="processing"
                                            :disabled="processing"
                                            @click="handleSubmit"
                                            >Submit</a-button>
                                        <a-button
                                            @click="handleClose"
                                            :loading="processing"
                                            :disabled="processing"
                                            >Tutup</a-button>
                                    </a-space>
                                </a-col>
                            </a-row>
                        </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const modules = [
    { label: 'Klasikal', value: 'classical' },
    { label: 'Performance', value: 'performance' },
    { label: 'Makalah', value: 'paper' },
    { label: 'Project Management', value: 'project' },
    { label: 'Evaluasi', value: 'evaluation' },
]

export default {
    props: {
        hash: {
            type: String,
            default: ''
        },
        training: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            modules,
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            modulesExisting: [],
            formData: {}
        }
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getItem()
        }
        this.getModules()
    },
    computed: {
        editing() {
            return this.hash !== "";
        },
        modulesAdd(){
            let collection = []

            this.modules.forEach(item => {
                    let newArr = this.modulesExisting.filter(function(ele){
                        return (ele.module.identifier == item.value)
                    })

                    if(newArr.length == 0){
                        collection.push({label: item.label, value: item.value})
                    }
                }
            )

            return collection
        }
    },
    methods: {
        getModules() {
            this.preload = true
            this.$http
                .get(this.routeUri("api.training-modules", {training: this.training}))
                .then(response => this.modulesExisting = response.data.modules)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.processing = true;

            let promise;

            if(!this.editing){
                promise = this.$http.post(
                    this.routeUri("api.training-modules.store", {training: this.training}),
                    this.formData
                );
            }else{
                promise = this.$http.put(
                    this.routeUri("api.training-modules.update", {module: this.id}),
                    this.formData
                );
            }

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.$emit("handleClose", true);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
        onStartDateChange(date, dateString) {
            this.formData.date_start = dateString
        },
        onEndDateChange(date, dateString) {
            this.formData.date_end = dateString
        },
    }
}
</script>